export default "__VITE_ASSET__BfftpENH__"